

/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 4/20/20
 * Copyright All Rights Reserved
 */
// @flow
import * as React from 'react';
import { Field } from 'redux-form';
import mapItemsToOptions from 'components/support/forms/SelectMenus/mapItemsToOptions';

type Props = {
  component: string | React.ComponentType<any>,
  items: { id: string, name: string, value: string }[],
  name: string,
  includeEmptyOption?: boolean,
}

const BasicReduxFormSelectMenu = ({
  component, items, name, includeEmptyOption, ...rest
}: Props) => (
  <Field
    {...rest}
    component={component}
    name={name}
    type="select"
  >
    { includeEmptyOption && <option /> }
    {mapItemsToOptions(items)}
  </Field>
);

BasicReduxFormSelectMenu.defaultProps = {
  includeEmptyOption: true,
};

export default BasicReduxFormSelectMenu;



// WEBPACK FOOTER //
// ./js/components/support/forms/SelectMenus/BasicReduxFormSelectMenu/index.jsx